import React, { createContext, MutableRefObject, PropsWithChildren, useRef } from 'react';

export type CloseRequestedHandler = (eventId?: string) => void;

// Holds the handler the mounted assessment registers for ASSESSMENT_CLOSE_REQUESTED, so
// useAssessmentsNativeBridge (above the assessment, in UnauthenticatedAssessmentsGuard) can call
// into it. Null outside AssessmentsNativeBridgeProvider.
export const AssessmentsNativeBridgeContext =
  createContext<MutableRefObject<CloseRequestedHandler | null> | null>(null);

export const AssessmentsNativeBridgeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const closeRequestedHandlerRef = useRef<CloseRequestedHandler | null>(null);

  return (
    <AssessmentsNativeBridgeContext.Provider value={closeRequestedHandlerRef}>
      {children}
    </AssessmentsNativeBridgeContext.Provider>
  );
};
